import React, { useState, useContext } from 'react';
import ForgotPasswordModal from '../components/modals/ForgotPasswordModal';

// This component expects to receive AuthContext as a prop to avoid circular dependencies
const LoginPage = ({ AuthContext }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  
  const { login } = useContext(AuthContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const result = await login(email, password);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8" style={{backgroundColor: '#1A1E2E'}}>
      <ForgotPasswordModal 
        isOpen={showForgotPasswordModal} 
        onClose={() => setShowForgotPasswordModal(false)} 
      />
      
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* CIEMO Logo */}
        <div className="flex justify-center mb-6">
          <img 
            src="/cimeo-logo.png" 
            alt="CIMÉO Logo" 
            style={{
              width: '180px',
              height: 'auto',
              filter: 'drop-shadow(0 4px 16px rgba(0, 194, 255, 0.5)) drop-shadow(0 0 20px rgba(0, 194, 255, 0.3))',
              animation: 'pulse-glow 3s ease-in-out infinite'
            }}
          />
        </div>
        
        <h2 className="mt-6 text-center text-3xl font-extrabold" style={{color: '#FFFFFF'}}>
          Connexion à votre compte
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="py-8 px-4 shadow-lg sm:rounded-lg sm:px-10" style={{backgroundColor: '#2C3148'}}>
          <form onSubmit={handleLogin} className="space-y-6" data-testid="login-form">
            <div>
              <label className="block text-sm font-medium" style={{color: '#FFFFFF'}}>
                Adresse email
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2"
                style={{
                  backgroundColor: '#242A3D',
                  borderColor: '#4A5BFF',
                  color: '#FFFFFF'
                }}
                data-testid="login-email-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium" style={{color: '#FFFFFF'}}>
                Mot de passe / Code d&apos;accès
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2"
                style={{
                  backgroundColor: '#242A3D',
                  borderColor: '#4A5BFF',
                  color: '#FFFFFF'
                }}
                data-testid="login-password-input"
              />
            </div>

            {error && (
              <div className="text-sm" style={{color: '#FFC107'}} data-testid="login-error">
                {error}
              </div>
            )}

            <div>
              <button
                type="submit"
                disabled={isLoading}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 transition-all duration-300"
                style={{
                  background: 'linear-gradient(135deg, #4A5BFF 0%, #7A5FFF 100%)',
                  color: '#FFFFFF'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(74, 91, 255, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '';
                }}
                data-testid="login-submit-btn"
              >
                {isLoading ? 'Connexion...' : 'Se connecter'}
              </button>
            </div>
            
            <div className="text-center">
              <button
                type="button"
                onClick={() => setShowForgotPasswordModal(true)}
                className="text-sm transition-colors duration-200"
                style={{color: '#00C2FF'}}
                onMouseEnter={(e) => e.currentTarget.style.color = '#4A5BFF'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#00C2FF'}
                data-testid="forgot-password-link"
              >
                Mot de passe oublié?
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
